import { makeStyles } from '@material-ui/core';
import FlagstoneTheme from '../../config/flagstoneTheme';

export default function BackNextButton(props) {

    const classes = useStyles();

    

    return (

        <button className={classes.button} style={{alignSelf:props.next?"flex-end":"flex-start"}} onClick={() => props.action()}>{props.next? "NEXT":"BACK"}</button>

    )
}

const useStyles = makeStyles({
    button: {
        border: "none",
        outline: "none",
        cursor: "pointer",
        backgroundColor: FlagstoneTheme.palette.primary.main,
        marginTop: "50px",
        color: "white",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        fontSize: "14px",
        width: "100px",
        height: "40px",
    },

});